import { Injectable } from '@angular/core';
import { GridRow } from '@app/core/components/grid/grid.types';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class GridBookingService {
    constructor(private datatask: DataTaskService) {}

    /** @datatask 3268 */
    public async getPage(params: GridBookingPageParams): Promise<GridBookingGet> {
        return (await this.datatask.Post(3268, params))[0];
    }

    /** @datatask 3272 */
    public async addRow(params: GridBookingAddRowParams): Promise<GridRow> {
        const response = await this.datatask.Post(3272, params);
        return Array.isArray(response) ? response[0] : response;
    }

    /** @datatask 3269 */
    public async getTotals(rows: GridRow[]): Promise<GridBookingTotals> {
        return (await this.datatask.Post(3269, { rows }))[0];
    }

    /** @datatask 3270 */
    public async updateRow(params: GridBookingRowChangeParams): Promise<Partial<GridRow>> {
        return (await this.datatask.Post(3270, params))[0];
    }

    public async process(method: number, params: GridBookingProcessParams): Promise<GridBookingProcessResponse> {
        return (await this.datatask.Post(method, params))[0];
    }
}

export interface GridBookingPageParams {
    grid_datatask_keyno: number;
    grid_datatask_params: unknown;
    dataitem: GridRow | null;
    dataitems: GridRow[];
}

export interface GridBookingAddRowParams {
    last_row?: GridRow;
    dataitem: GridRow | null;
}

export type GridBookingRowChangeParams = GridRow & {
    colname_changed: string;
};

export interface GridBookingTotals {
    amount: string | number;
    amount_vat: string | number;
}

export interface GridBookingProcessParams {
    button: 'create_acvoucher' | 'bookkeep';
    voucher: GridBookingVoucher;
    rows: GridRow[];
    files: GridBookingFile[];
    grid_datatask_keyno?: number | null;
    grid_datatask_params: unknown;
}

export interface GridBookingFile {
    filename: string;
    base64: string;
}

export interface GridBookingProcessResponse extends ErrorMessageResponse {
    [key: string]: unknown;
}

export interface GridBookingVoucher {
    amount?: string;
    amount_vat?: string;
    amount_locval_balance?: unknown;
    transdate: string;
    voucherdate: string;
    note: string;
}

export interface GridBookingGet {
    heading: string;
    label_bookkeep: string;
    suggested_rows: string;
    book_datatask_keyno: string;
    note: string;
}
